import React from 'react'
import {LinkType, Mod} from '../../types'
import {Link, toFullPath} from '../../util/link'
import {Styler} from '../../util/style'

export const Navlinks: React.FC<{
	styles: Styler
	mod?: Mod<string>
	links: Array<LinkType>
	onClick?: () => void
}> = ({styles, mod, links, onClick}) => {
	if (!links || links.length === 0) return null

	return (
		<nav className={styles().mod(mod)}>
			{links.map((link) => {
				if (!link) return null
				if (link.type === 'project') link.url = toFullPath('', link.path)
				if (!link.url) return null

				return (
					<div key={link.url} className={styles('item')}>
						<Link
							strict={true}
							to={link.url}
							onClick={onClick}
							className={styles('item-link')}
						>
							{link.description || link.title}
						</Link>
					</div>
				)
			})}
		</nav>
	)
}
